import { render } from "./userBlock.vue?vue&type=template&id=c20a61d8&scoped=true"
import script from "./userBlock.vue?vue&type=script&lang=js"
export * from "./userBlock.vue?vue&type=script&lang=js"

import "./userBlock.vue?vue&type=style&index=0&id=c20a61d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c20a61d8"]])

export default __exports__